import { render, staticRenderFns } from "./ArchiveProducts.vue?vue&type=template&id=a71481b0&scoped=true&"
import script from "./ArchiveProducts.vue?vue&type=script&lang=js&"
export * from "./ArchiveProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71481b0",
  null
  
)

export default component.exports